import { gql, useMutation, useQuery } from '@apollo/client';

function useCompleteTheLook(variables) {
  const [logError] = useMutation(LOG_ERROR);
  const { loading, error, data } = useQuery(COMPLETE_THE_LOOK, {
    variables: variables,
    onCompleted(data) {
      if (!data) {
        logError({
          variables: {
            error: `Complete the look could not load ${
              props.cart ? 'in cart' : 'in pdp'
            }`
          }
        });
      }
    }
  });

  return { error, data, loading };
}

export default useCompleteTheLook;

const LOG_ERROR = gql`
  mutation logError($error: String!) {
    logError(error: $error) {
      success
    }
  }
`;

const COMPLETE_THE_LOOK = gql`
  query completeTheLook($sku: String, $sorting: String, $limit_items: Int) {
    completeTheLook(sku: $sku, sorting: $sorting, limit_items: $limit_items) {
      id
      sku
      name
      price
      slug
      is_swatch
      is_purchasable
      badge_treatment {
        id
        name
      }
      images {
        id
        name
        path
        width
        height
      }
      fabric {
        id
        is_available_on_pdp
        name
        image
        collaborator {
          id
          name
        }
        material {
          id
          name
        }
      }
      leg {
        id
        name
      }
      frame {
        id
        name
        orientation
        size {
          id
          is_available_on_pdp
          name
        }
        subcategories {
          id
          category {
            id
            name
          }
        }
      }
    }
  }
`;
